import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { RadioButton } from 'primereact/radiobutton';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useLocalStorage } from 'primereact/hooks';
import { useTheme } from "../ThemeContext";

export default function SidebarDatacount(props) {
    const { visible, setVisible , showMessage, setLoading} = props;
    const { changeTheme } = useTheme();
    const [theme, setTheme] = useLocalStorage('theme', 'selectedTheme');

    const themes = [
        "lara-light-blue", "lara-light-indigo", "lara-light-purple", "lara-light-teal",
        "lara-dark-blue", "lara-dark-indigo", "lara-dark-purple", "lara-dark-teal",
        "soho-light", "soho-dark", "viva-light", "viva-dark", "mira", "nano", "vela-orange", "saga-orange", "arya-orange", "arya-purple"
    ];

    React.useEffect(() => {
        if(visible){
            const link = document.getElementById('theme-link');
            if (link) {
                link.href = `/styles/${theme}.css`;
                console.log('Tema mudado no SideBarDatacount ' + link.href)
            }
            setTheme(theme);
        }
        
    }, [theme]);
   
    return (
        <div className="card flex justify-content-center">
            <Sidebar visible={visible} onHide={() => setVisible(!visible)} position="right">
                <div className="flex flex-column h-full">
                    <div className="flex align-items-center justify-content-center">
                        <span className="font-semibold text-lg text-primary">CONFIGURAÇÕES</span>
                    </div>

                    <Accordion activeIndex={0} className="mt-3" style={{border:'none'}}>                        
                        <AccordionTab header="Tema">
                            <div className="flex flex-column gap-2 text-sm">
                                {themes.map((t) => (
                                    <div key={t} className="flex align-items-center">
                                        <RadioButton
                                            inputId={t}
                                            name="theme"
                                            value={t}
                                            onChange={(e) => setTheme(e.value)}
                                            checked={theme === t}
                                        />
                                        <label htmlFor={t} className="ml-2">{t.replace(/-/g, ' ').toUpperCase()}</label>
                                    </div>
                                ))}
                            </div>
                        </AccordionTab>
                    </Accordion>
                </div>
            </Sidebar>
        </div>
    );
}
